// @flow
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { compose } from 'react-recompose';
import { withNavigation } from '@react-navigation/compat';
import ValidationService from '../../../../lib/validation';
import { confirmKeptPhoneNumber } from '../../../../modules/SignUp/PhoneNumber';
import KeepNumber from './KeepNumber';
import { isLoadingSelector } from '../../../../modules/LoadingStatus';
import { regionSelector } from '../../../../modules/SignUp/Region/selectors';
import config from '../../../../config';

const getLocalPhoneIndicative = state => {
  const region = regionSelector(state);
  const indicative = region ? config.LOCAL_PHONE_INDICATIVE[region.name] : '';
  return indicative;
};

const validate = (values, ownProps) => {
  if (values.cheatCode) {
    return null;
  }

  return {
    phoneNumber: ValidationService.validateLocalPhoneNumber(
      values.phoneNumber,
      ownProps.selectedRegion.phoneRegionName
    ),
    RIONumber: ValidationService.validateRioNumber(values.RIONumber, values.phoneNumber),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: values => {
    dispatch(
      confirmKeptPhoneNumber(
        {
          phoneNumber: values.phoneNumber,
          rioNumber: values.RIONumber.toUpperCase(), // tempporary workaround to capitalize RIO
        },
        ownProps.isActivationPath
      )
    );
  },
});

const mapStateToProps = state => ({
  phoneNumber: keepNumberFormValueSelector(state, 'phoneNumber'),
  isLoading: isLoadingSelector(state, 'confirmKeptPhoneNumber'),
  selectedRegion: regionSelector(state),
  localPhoneIndicative: getLocalPhoneIndicative(state),
});

const keepNumberFormValueSelector = formValueSelector('keepNumber');

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: 'keepNumber', validate }),
  withNavigation
);

export default enhance(KeepNumber);
